import { OutlinedTextFieldProps, TextField, Typography } from '@material-ui/core';
import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { CustomTypography, InputDiv } from './Input.styled';

interface IProps extends Partial<FieldRenderProps<string>> {
  label?: string;
  disableAutocomplete?: boolean;
  textFieldProps?: Omit<OutlinedTextFieldProps, 'variant'>;
  disabled?: boolean;
}

type PropType = IProps;

const CustomField = ({ meta, input, label, textFieldProps, disableAutocomplete, disabled }: PropType): JSX.Element => {
  const { t } = useTranslation();
  const shouldDisplayError = (typeof meta?.error === 'boolean' || (meta?.error && meta?.touched)) as boolean;

  return (
    <InputDiv>
      {label && (
        <CustomTypography color="textSecondary" variant="subtitle2">
          {t(label)}
        </CustomTypography>
      )}
      <TextField
        {...textFieldProps}
        error={shouldDisplayError}
        variant="outlined"
        inputProps={input}
        disabled={disabled}
        autoComplete={disableAutocomplete ? 'new-password' : textFieldProps?.type}
        margin="dense"
      />
      {!disabled && shouldDisplayError && typeof meta?.error !== 'boolean' && (
        <Typography variant="caption" color="error">
          {t(meta?.error as string)}
        </Typography>
      )}
    </InputDiv>
  );
};

export default CustomField;
